<template>
  <div class="d d_xm">
    <headers :goBack="goBack" :isForm="1" />
    <div class="title">
      省、市、县三级总辅导员信息统计
      <div class="tip">（由省、市、县相应的少工委相关同志填写）</div>
    </div>
    <van-form
      @submit="onClickButtonSubmit"
      validate-trigger="onSubmit"
      @failed="handleFailed"
    >
    <div class="kuang">
      <van-field
       class="d_f"
        required
        v-model="states.name"
        clearable
        label="姓名"
        placeholder="请输入姓名"
        :rules="[{ required: true, message: '请填写姓名' }]"
      />
      <van-field
       class="d_f"
        required
        v-model="states.nameSure"
        clearable
        label="确认姓名"
        placeholder="请输入姓名"
        :rules="[{ required: true, message: '请确认姓名' }]"
        :error="nameDifferent"
        :error-message="errorMessageName"
        @blur="validateInputsName"
        @paste.prevent
        
      />
      <van-field
       class="d_f"
        required
        v-model="states.idCard"
        clearable
        label="身份证号"
        placeholder="请输入身份证号"
        maxlength="18"
        :rules="[{ required: true, message: '请填写身份证号' },
          {
            validator: validateIdCard,
            message: '请输入合法的18位身份证号'
          }
        ]"
        :error="idCardFormatDifferent"
        :error-message="errorMessageIdCardFormat"
        @blur="validateInputIdCardFormat"
      />
      <van-field
       class="d_f"
        required
        v-model="states.idCardSure"
        clearable
        label="确认身份证号"
        placeholder="请确认身份证号"
        maxlength="18"
        :rules="[{ required: true, message: '请确认身份证号' }]"
        :error="idCardDifferent"
        :error-message="errorMessageIdCard"
        @blur="validateInputsIdCard"
        @paste.prevent
      />
      <van-field
        required
        name="radio"
        label="性别"
        class="radioFlex d_f"
        :rules="[{ required: true, message: '请选择性别' }]"
      >
        <template #input>
          <van-radio-group
            v-model="states.sex"
            direction="horizontal"
            v-for="item in sexs"
            v-bind:key="item.key"
          >
            <van-radio :name="item.key" checked-color="#ff6865">{{
              item.value
            }}</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <datetime-picker
        :value="states.birthday"
        title="出生年月"
        type="year-month"
        :callback="(val) => handlerSelect('birthday', val)"
        :isRequired="birthdayFlag"
      />
      <van-field
      class="d_f"
        required
        v-model="states.phone"
        clearable
        label="手机号"
        placeholder="请输入手机号"
        type="number"
        maxlength="11"
        :rules="[{ required: true, message: '请填写手机号' },
          {
            validator: (val) => val.length === 11,
            message: '请输入11位手机号'
          }
        ]"
        :error="PhoneFormatDifferent"
        :error-message="errorMessagePhoneFormat"
        @blur="validateInputsPhoneFormat"
      />
      <van-field
      class="d_f"
        required
        v-model="states.phoneSure"
        clearable
        label="确认手机号"
        placeholder="请确认手机号"
        type="number"
        maxlength="11"
        :rules="[{ required: true, message: '请确认手机号' }]"
        :error="phoneDifferent"
        :error-message="errorMessagePhone"
        @blur="validateInputsPhone"
        @paste.prevent
      />
      <van-field
      class="d_f"
        required
        v-model="states.xingzheng"
        clearable
        label="行政区域">
        <template #input>
          <AddressGenerel
            :province="states.province"
            :city="states.city"
            :district="states.district"
            :selectArea="selectArea"
          ></AddressGenerel>
        </template>
      </van-field>
      <van-field
      class="d_f"
        required
        name="radio"
        label="政治面貌"
        :rules="[{ required: true, message: '请选择政治面貌' }]"
      >
        <template #input>
          <van-radio-group
            v-model="states.zzmm"
            v-for="item in zzmmList01"
            v-bind:key="item.key"
          >
            <van-radio :name="item.key" checked-color="#ff6865">{{
              item.value
            }}</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <diy-picker
        title="总辅导员级别"
        :value="states.fdyLevTxt"
        :list="(states.province == '北京市' || states.province == '天津市' || states.province == '上海市' || states.province == '重庆市') ? fdySXLevList : fdyLevList"
        :handlerSelect="selectFdyLev"
        :isClick="true"
        :isRequired="fdyLevFlag"
      />
      <template v-if="states.fdyLevKey == 3">
        <van-field
         class="d_f"
          required
          v-model="states.quFdyNum"
          clearable
          label="本县（市、区、旗）所属乡镇（街道）总辅导员数量"
          placeholder="请输入"
          :rules="[{ required: true, message: '请输入本县（市、区、旗）所属乡镇（街道）总辅导员数量' },
          { validator: (value) => Number(value) <= 200,  // 核心验证逻辑
            message: '数量超过200，请注意', 
            trigger: 'onBlur'
          }]"
        />
        <van-field
         class="d_f"
          required
          v-model="states.quFdyNumSure"
          clearable
          label="确认本县（市、区、旗）所属乡镇（街道）总辅导员数量"
          placeholder="请输入"
          :rules="[{ required: true, message: '请输入本县（市、区、旗）所属乡镇（街道）总辅导员数量' }]"
          :error="quFdyDifferent"
          :error-message="errorMessageQuFdy"
          @blur="validateInputsQuFdy"
        />
      </template>
      <van-field
      
        name="radio"
        label="本级是否有红领巾巡讲团"
        class="radioFlex d_f"
        required
        :rules="[{ required: true, message: '请选择是否有红领巾巡讲团' }]"
      >
        <template #input>
          <van-radio-group
            v-model="states.isHljXjt"
            @change="handleHljRadioChange"
            direction="horizontal"
            v-for="item in yORn"
            v-bind:key="item.key"
          >
            <van-radio :name="item.key" checked-color="#ff6865">{{
              item.value
            }}</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <template v-if="states.isHljXjt == true">
        <van-field
          class="d_f"
          required
          v-model="states.hljXjtNum"
          @blur="onBlur"
          clearable
          label="本级红领巾巡讲团人数"
          placeholder="请输入"
          type="number"
          @paste.prevent
          :rules="[{ required: true, message: '请输入本级红领巾巡讲团人数' },
          { validator: (value) => Number(value) <= 260,  // 核心验证逻辑
            message: '数量超过260，请注意', 
            trigger: 'onBlur'
          }]"
        />
        <van-field
          class="d_f"
          required
          v-model="states.hljXjtNumSure"
          clearable
          label="确认本级红领巾巡讲团人数"
          placeholder="请输入"
          type="number"
          @paste.prevent
          :rules="[{ required: true, message: '请确认本级红领巾巡讲团人数' }]"
          :error="areInputsDifferent"
          :error-message="errorMessage"
          @blur="validateInputs"
        />
      </template>
      <diy-picker
        title="全日制教育学历"
        :value="states.eduTxt"
        :list="eduList01"
        :handlerSelect="selectEdu"
        :isClick="true"
        :isRequired="eduFlag"
      />
      <diy-picker
        title="所学专业大类"
        :value="states.majorTxt"
        :list="majorList"
        :handlerSelect="selectMajor"
        :isClick="true"
        :isRequired="majorFlag"
      />
      <van-field
        name="radio"
        label="毕业院校是否为港澳台或国外院校"
        class="radioFlex d_f"
        required
        :rules="[{ required: true, message: '请选择毕业院校是否为港澳台或国外院校' }]"
      >
        <template #input>
          <van-radio-group
            v-model="states.isGatOrAbroad"
            direction="horizontal"
            v-for="item in yORn"
            v-bind:key="item.key"
          >
            <van-radio 
              :name="item.key" 
              checked-color="#ff6865"
              @click="handleGatOrAbroadRadioChange(item.key)"
            >{{
              item.value
            }}</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <school v-if="states.isGatOrAbroad == 2 && states.collegeKey != -1"
        title="毕业院校"
        :value="states.collegeTxt"
        :handlerSelect="selectCollege"
        :isClick="true"
        :isRequired="collegeFlag"
      />
      <van-field v-if="states.isGatOrAbroad == 1 || states.collegeKey == -1"
        required
        v-model="states.collegeTxt"
        clearable
        label="毕业院校"
        placeholder="请输入毕业院校"
        :rules="[{ required: true, message: '请填写毕业院校' }]"
      />
      <diy-picker
        title="最高教育学历"
        :value="states.highestEduTxt"
        :list="highestEduList"
        :handlerSelect="selectHighestEdu"
        :isClick="true"
        :isRequired="highestEduFlag"
      />
      <template v-if="states.highestEduKey == 2 || states.highestEduKey == 3 || states.highestEduKey == 4 || states.highestEduKey == 5 || states.highestEduKey == 6">
        <diy-picker
          title="所学专业大类"
          :value="states.highestMajorTxt"
          :list="majorList"
          :handlerSelect="selectHighestMajor"
          :isClick="true"
          :isRequired="highestMajorFlag"
        />
        <van-field
          name="radio"
          label="毕业院校是否为港澳台或国外院校"
          class="radioFlex d_f"
          required
          :rules="[{ required: true, message: '请选择毕业院校是否为港澳台或国外院校' }]"
        >
          <template #input>
            <van-radio-group
              v-model="states.isHighestGatOrAbroad"
              direction="horizontal"
              v-for="item in yORn"
              v-bind:key="item.key"
            >
              <van-radio 
                :name="item.key" 
                checked-color="#ff6865"
                @click="handleHighestGatOrAbroadRadioChange(item.key)"
              >{{
                item.value
              }}</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <school v-if="states.isHighestGatOrAbroad == 2 && states.highestCollegeKey != -1"
          title="毕业院校"
          :value="states.highestCollegeTxt"
          :handlerSelect="selectHighestCollege"
          :isClick="true"
          :isRequired="highestCollegeFlag"
        />
        <van-field v-if="states.isHighestGatOrAbroad == 1 || states.highestCollegeKey == -1"
          required
          v-model="states.highestCollegeTxt"
          clearable
          label="毕业院校"
          placeholder="请输入毕业院校"
          :rules="[{ required: true, message: '请填写毕业院校' }]"
        />
        <diy-picker
          title="最高教育学历性质"
          :value="states.highestEduXZTxt"
          :list="highestEduXZList"
          :handlerSelect="selectHighestEduXZ"
          :isClick="true"
          :isRequired="highestEduXZFlag"
        />
      </template>
      <diy-picker
        title="本人编制所在单位"
        :value="states.organizationTxt"
        :list="organizationList"
        :handlerSelect="selectOrganization"
        :isClick="true"
        :isRequired="organizationFlag"
      />
      <diy-picker
        title="团内职务"
        :value="states.tuanJobTxt"
        :list="tuanJobList"
        :handlerSelect="selectTuanJob"
        :isClick="true"
        :isRequired="tuanJobFlag"
      />
      <diy-picker
        title="本人编制类型"
        :value="states.jobTypeTxt"
        :list="jobTypeList"
        :handlerSelect="selectJobType"
        :isClick="true"
        :isRequired="jobTypeFlag"
      />
      <diy-picker v-if="states.jobTypeKey == 1 || states.jobTypeKey == 2"
        title="行政（事业）级别"
        :value="states.jobLevTxt"
        :list="jobLevList"
        :handlerSelect="selectJobLev"
        :isClick="true"
        :isRequired="jobLevFlag"
      />
      <template v-if="states.organizationKey == 5">
        <diy-picker
          title="任教学科门数"
          :value="states.teachSubjectNumTxt"
          :list="teachSubjectNumList"
          :handlerSelect="selectTeachSubjectNum"
          :isClick="true"
          :isRequired="teachSubjectNumFlag"
        />
        <SelectMultiple v-if="states.teachSubjectNumKey !== 1"
          title="任教学科"
          :value="states.teachSubjectsKeyArray"
          :list="teachSubjectsList"
          :handlerSelect="selectTeachSubjects"
          :isClick="true"
          :isRequired="teachSubjectsFlag"
        />
        <van-field v-if="states.isHasOtherTeachSubjects && states.isHasOtherTeachSubjects == true"
          required
          v-model="states.otherTeachSubject"
          clearable
          label="其他任教学科名称"
          placeholder="请确认其他任教学科名称"
          :rules="[{ required: true, message: '请输入其他任教学科名称' }]"
        />
      </template>
      <template v-if="states.fdyLevKey == 3">
        <van-field
          class="d_f"
          required
          v-model="states.b63"
          clearable
          label="本县（市、区、旗）登记在册的校外辅导员人数"
          placeholder="请输入本县（市、区、旗）登记在册的校外辅导员人数"
          :rules="[{ required: true, message: '请填写本县（市、区、旗）登记在册的校外辅导员人数' }]"
        />
        <van-field
          class="d_f"
          required
          v-model="states.b63Sure"
          clearable
          label="确认本县（市、区、旗）登记在册的校外辅导员人数"
          placeholder="请确认本县（市、区、旗）登记在册的校外辅导员人数"
          :rules="[{ required: true, message: '请确认本县（市、区、旗）登记在册的校外辅导员人数' }]"
          :error="b63Different"
          :error-message="errorMessageB63"
          @blur="validateInputsB63"
        />
        <van-field
        class="d_f"
          required
          v-model="states.b7"
          clearable
          label=""
          placeholder="请输入本县（市、区、旗）未建立少先队组织的中小学校数量"
          :rules="[{ required: true, message: '请填写本县（市、区、旗）未建立少先队组织的中小学校数量' }]"
        >
          <template #label>
                <span>本县（市、区、旗）未建立<span class="fz-bold">少先队组织</span>的中小学校数量</span>
          </template>
        </van-field>
        <van-field
        class="d_f"
          required
          v-model="states.b7Sure"
          clearable
          label=""
          placeholder="请确认本县（市、区、旗）未建立少先队组织的中小学校数量"
          :rules="[{ required: true, message: '请确认本县（市、区、旗）未建立少先队组织的中小学校数量' }]"
          :error="b7Different"
          :error-message="errorMessageB7"
          @blur="validateInputsB7"
        >
        <template #label>
                <span>确认本县（市、区、旗）未建立<span class="fz-bold">少先队组织</span>的中小学校数量</span>
          </template>
        </van-field>
        <van-field
        class="d_f"
          required
          v-model="states.b8"
          clearable
          label=""
          placeholder="请输入本县（市、区、旗）未建立学校少工委的中小学校数量"
          :rules="[{ required: true, message: '请填写本县（市、区、旗）未建立学校少工委的中小学校数量' }]"
        >
          <template #label>
            <spanrr>本县（市、区、旗）未建立<span class="fz-bold">学校少工委</span>的中小学校数量</spanrr>
          </template>
        </van-field>
        <van-field
        class="d_f"
          required
          v-model="states.b8Sure"
          clearable
          label=""
          placeholder="请确认本县（市、区、旗）未建立学校少工委的中小学校数量"
          :rules="[{ required: true, message: '请确认本县（市、区、旗）未建立学校少工委的中小学校数量' }]"
          :error="b8Different"
          :error-message="errorMessageB8"
          @blur="validateInputsB8"
        >
        <template #label>
            <span>确认本县（市、区、旗）未建立<span class="fz-bold">学校少工委</span>的中小学校数量</span>
          </template>
        </van-field>
        
      </template>

      <van-field
      class="d_f"
        required
        v-model="states.qsngNum"
        clearable
        label="由本级少工委直管的建有少先队组织的青少年宫数量（没有的须填“0”）"
        placeholder="请输入由本级少工委直管的建有少先队组织的青少年宫个数"
        :rules="[{ required: true, message: '请填写由本级少工委直管的建有少先队组织的青少年宫个数' },{ validator: (value) => Number(value) >= 0 && Number(value) <= 50,  // 核心验证逻辑
            message: '限制填写数量0至50，请注意', 
            trigger: 'onBlur'
          }]"
      />
      <van-field
      class="d_f"
        required
        v-model="states.qsngNumSure"
        clearable
        label="确认由本级少工委直管的建有少先队组织的青少年宫数量"
        placeholder="请确认由本级少工委直管的建有少先队组织的青少年宫个数"
        :rules="[{ required: true, message: '请确认由本级少工委直管的建有少先队组织的青少年宫个数' }]"
        :error="qsngNumDifferent"
        :error-message="errorMessageQsngNum"
        @blur="validateInputsQsngNum"
      />


      <template v-if="states.fdyLevKey == 3">
        
        <van-field
        class="d_f"
          required
          v-model="states.jljdsgwNum"
          clearable
          label=""
          placeholder="本县（市、区、旗）建立的街道少工委数量"
          :rules="[{ required: true, message: '请填写本县（市、区、旗）建立的街道少工委数量' },{ validator: (value) => Number(value) >= 0 && Number(value) <= 500,  // 核心验证逻辑
            message: '限制填写数量0至500，请注意', 
            trigger: 'onBlur'
          }]"
        >
          <template #label>
            <span>本县（市、区、旗）建立的<span class="fz-bold">街道</span>少工委数量（没有的须填“0”）</span>
          </template>
        </van-field>
        <van-field
        class="d_f"
          required
          v-model="states.jljdsgwNumSure"
          clearable
          label=""
          placeholder="请确认本县（市、区、旗）建立的街道少工委数量"
          :rules="[{ required: true, message: '请确认本县（市、区、旗）建立的街道少工委数量' }]"
          :error="jljdsgwNumDifferent"
          :error-message="errorMessageJljdsgwNum"
          @blur="validateInputsJljdsgwNum"
        >
        <template #label>
            <span>确认本县（市、区、旗）建立的<span class="fz-bold">街道</span>少工委数量</span>
          </template>
        </van-field>


        <van-field
          class="d_f"
          required
          v-model="states.jlxzsgwNum"
          clearable
          label=""
          placeholder="本县（市、区、旗）建立的乡镇少工委数量"
          :rules="[{ required: true, message: '请填写本县（市、区、旗）建立的乡镇少工委数量' },{ validator: (value) => Number(value) >= 0 && Number(value) <= 500,  // 核心验证逻辑
            message: '限制填写数量0至500，请注意', 
            trigger: 'onBlur'
          }]"
        >
          <template #label>
            <span>本县（市、区、旗）建立的<span class="fz-bold">乡镇</span>少工委数量（没有的须填“0”）</span>
          </template>
        </van-field>
        <van-field
          class="d_f"
          required
          v-model="states.jlxzsgwNumSure"
          clearable
          label=""
          placeholder="请确认本县（市、区、旗）建立的乡镇少工委数量"
          :rules="[{ required: true, message: '请确认本县（市、区、旗）建立的乡镇少工委数量' }]"
          :error="jlxzsgwNumDifferent"
          :error-message="errorMessageJlxzsgwNum"
          @blur="validateInputsJlxzsgwNum"
        >
        <template #label>
            <span>确认本县（市、区、旗）建立的<span class="fz-bold">乡镇</span>少工委数量</span>
          </template>
        </van-field>



        <van-field
          class="d_f"
          required
          v-model="states.jlsqsgwNum"
          clearable
          label=""
          placeholder="本县（市、区、旗）建立的社区少工委数量"
          :rules="[{ required: true, message: '请填写本县（市、区、旗）建立的社区少工委数量' },{ validator: (value) => Number(value) >= 0 && Number(value) <= 500,  // 核心验证逻辑
            message: '限制填写数量0至500，请注意', 
            trigger: 'onBlur'
          }]"
        >
          <template #label>
            <span>本县（市、区、旗）建立的<span class="fz-bold">社区</span>少工委数量（没有的须填“0”）</span>
          </template>
        </van-field>
        <van-field
          class="d_f"
          required
          v-model="states.jlsqsgwNumSure"
          clearable
          label=""
          placeholder="请确认本县（市、区、旗）建立的社区少工委数量"
          :rules="[{ required: true, message: '请确认本县（市、区、旗）建立的社区少工委数量' }]"
          :error="jlsqsgwNumDifferent"
          :error-message="errorMessageJlsqsgwNum"
          @blur="validateInputsJlsqsgwNum"
        >
        <template #label>
            <span>确认本县（市、区、旗）建立的<span class="fz-bold">社区</span>少工委数量</span>
          </template>
        </van-field>



        <van-field
          class="d_f"
          required
          v-model="states.jlcsgwNum"
          clearable
          label=""
          placeholder="本县（市、区、旗）建立的村少工委数量"
          :rules="[{ required: true, message: '请填写本县（市、区、旗）建立的村少工委数量' },{ validator: (value) => Number(value) >= 0 && Number(value) <= 500,  // 核心验证逻辑
            message: '限制填写数量0至500，请注意', 
            trigger: 'onBlur'
          }]"
        >
          <template #label>
            <span>本县（市、区、旗）建立的<span class="fz-bold">村</span>少工委数量（没有的须填“0”）</span>
          </template>
        </van-field>
        <van-field
          class="d_f"
          required
          v-model="states.jlcsgwNumSure"
          clearable
          label=""
          placeholder="请确认本县（市、区、旗）建立的村少工委数量"
          :rules="[{ required: true, message: '请确认本县（市、区、旗）建立的村少工委数量' }]"
          :error="jlcsgwNumDifferent"
          :error-message="errorMessageJlcsgwNum"
          @blur="validateInputsJlcsgwNum"
        >
        <template #label>
            <span>确认本县（市、区、旗）建立的<span class="fz-bold">村</span>少工委数量</span>
          </template>
        </van-field>




        
        
      </template>


    </div>


      <!--登录按钮-->
      <div style="margin: 16px">
        <van-button round block type="primary" native-type="submit" class="btn btn_dl">
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script setup>
import { reactive, ref, onMounted, getCurrentInstance } from "vue";
import headers from "../../../components/Header.vue";
import { useRoute, useRouter } from "vue-router";
import datetimePicker from "@/components/DatePicker";
import diyPicker from "@/components/Select";
import school from "@/components/School"
import SelectMultiple from "../../../components/SelectMultiple.vue";
import AddressGenerel from "../../../components/AddressGenerel.vue";
import { addForm, editForm, getsubmitData } from "../../../service/form";
import { tipsMsg, getKey, encrypt, rsaUtil, serverPublicKey } from "../../../common/js";
import { Dialog } from "vant";
import { format } from "@/common/js/utils";
import {
  sexs,
  zzmmList01,
  fdyLevList,
  fdySXLevList,
  yORn,
  eduList01,
  majorList,
  highestEduList,
  highestEduXZList,
  organizationList,
  tuanJobList,
  jobTypeList,
  jobLevList,
  teachSubjectNumList,
  teachSubjectsList
} from "@/common/js/field";
const route = useRoute();
const router = useRouter();
const { proxy } = getCurrentInstance();
const state = reactive({
  birthdayFlag: false,
});
const states = reactive({
  name: null,
  nameSure: null,
  idCard: null,
  idCardSure: null,
  sex: null,
  // sexTxt: format(states.sex.value, 12),
  sexTxt: null,
  birthday : null,
  phone: null,
  phoneSure: null,
  province:'不限',
  city: '不限',
  district: '不限',
  provinceCode: null,
  cityCode: null,
  districtCode: null,
  zzmm: null,
  // zzmmTxt: format(states.zzmm.value, 21),
  zzmmTxt: null,
  fdyLevTxt: '请选择',
  fdyLevKey: null,
   quFdyNum: null,
   quFdyNumSure: null,
   isHljXjt: null,
  //  isHljXjtTxt: format(states.isHljXjt.value, 1),
  isHljXjtTxt: null,
   hljXjtNum: null,
   hljXjtNumSure: null,
   eduKey: null,
   eduTxt: '请选择',
   majorKey: null,
   majorTxt: '请选择',
   isGatOrAbroad: null,
   isGatOrAbroadTxt: null,
   collegeKey: null,
   collegeTxt: '请选择',
   highestEduKey: null,
   highestEduTxt: '请选择',
   highestMajorKey: null,
   highestMajorTxt: '请选择',
   isHighestGatOrAbroad: null,
   isHighestGatOrAbroadTxt: null,
   highestCollegeKey: null,
   highestCollegeTxt: '请选择',
   highestEduXZKey: null,
   highestEduXZTxt: '请选择',
   organizationKey: null,
   organizationTxt: '请选择',
   tuanJobKey: null,
   tuanJobTxt: '请选择',
   jobTypeKey: null,
   jobTypeTxt: '请选择',
   jobLevKey: null,
   jobLevTxt: '请选择',
   teachSubjectNumKey: null,
   teachSubjectNumTxt: '请选择',
   teachSubjectsKeyArray: [],
   teachSubjectsTxtArray: [],
  //  teachSubjectsTxt: computed(() => {
  //   return states.teachSubjectsTxtArray.value.length > 0 
  //     ? states.teachSubjectsTxtArray.value.join(", ") 
  //     : "请选择";
  // }),
   isTeachSubjectsMatch: false,
   isHasOtherTeachSubjects: false,
   otherTeachSubject: null,
   b63: null,
   b63Sure: null,
   b7: null,
   b7Sure: null,
   b8: null,
   b8Sure: null,
   qsngNum: null,
   qsngNumSure: null,
   jljdsgwNum: null,
   jljdsgwNumSure: null,
   jlxzsgwNum: null,
   jlxzsgwNumSure: null,

   jlsqsgwNum: null,
   jlsqsgwNumSure: null,

   jlcsgwNum: null,
   jlcsgwNumSure: null,


});
// const teachSubjectsTxt = computed(() => {
//   console.log("teachSubjectsTxtArray ->", states.teachSubjectsTxtArray);
//   return states.teachSubjectsTxtArray.length > 0 
//       ? states.teachSubjectsTxtArray.join(", ") 
//       : "请选择";
// });

// 身份证号验证函数
const validateIdCard = (val) => {
  // 检查长度是否为18位
  if (val.length !== 18) {
    return false;
  }
  // 检查前17位是否为数字
  for (let i = 0; i < 17; i++) {
    if (!/^\d$/.test(val.charAt(i))) {
      return false;
    }
  }
  // 检查第18位是否为数字或X（不区分大小写）
  if (!/^\d$|^[Xx]$/.test(val.charAt(17))) {
    return false;
  }
  // 加权因子和校验
  const weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
  const checkCodes = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
  let sum = 0;
  for (let i = 0; i < 17; i++) {
    sum += parseInt(val.charAt(i), 10) * weights[i];
  }
  const mod = sum % 11;
  const expectedCheckCode = checkCodes[mod];
  // 注意：这里需要比较的是val的第18位（转换为大写）与expectedCheckCode
  return val.charAt(17).toUpperCase() === expectedCheckCode;
};
//输入验证：身份证合法性验证
const idCardFormatDifferent = ref(false);
const errorMessageIdCardFormat = ref('');
const validateInputIdCardFormat = () => {
  if (!validateIdCard(states.idCard)){
    idCardFormatDifferent.value = true;
    errorMessageIdCardFormat.value = '请输入合法的18位身份证号';
  }else{
    idCardFormatDifferent.value = false;
    errorMessageIdCardFormat.value = '';
  }
};
//输入验证：身份证确认验证
const idCardDifferent = ref(false);
const errorMessageIdCard = ref('');
const validateInputsIdCard = () => {
  // 检查两个输入字段的值是否一致
  if (states.idCard !== states.idCardSure) {
    idCardDifferent.value = true;
    errorMessageIdCard.value = '身份证两次输入不一致';
  } else {
    idCardDifferent.value = false;
    errorMessageIdCard.value = '';
  }
};
const selectFdyLev = (key, value) => {
  states.fdyLevKey = key;
  states.fdyLevTxt = value;
  clearFdyLevHide();
  console.log("sexTxt=", states.quFdyNum);
};

function clearFdyLevHide(){
  if (states.fdyLevKey == 1 || states.fdyLevKey == 2){
    states.quFdyNum = null;
    states.quFdyNumSure = null;
    quFdyDifferent.value = false;
    errorMessageQuFdy.value = '';

    states.b63 = null;
    states.b63Sure = null;
    b63Different.value = false;
    errorMessageB63.value = '';

    states.b7 = null;
    states.b7Sure = null;
    b7Different.value = false;
    errorMessageB7.value = '';

    states.b8 = null;
    states.b8Sure = null;
    b8Different.value = false;
    errorMessageB8.value = '';
  }
}

const handleHljRadioChange = (value) => {
  if (value == 2){
    states.hljXjtNum = null;
    states.hljXjtNumSure = null;
    areInputsDifferent.value = false;
    errorMessage.value = '';
  }
};

const selectEdu = (key, value) => {
  states.eduKey = key;
  states.eduTxt = value;
};

const selectMajor = (key, value) => {
  states.majorKey = key;
  states.majorTxt = value;
};
const handleGatOrAbroadRadioChange = (key) => {
  states.isGatOrAbroad = key;
  states.isGatOrAbroadTxt = format(states.isGatOrAbroad, 1);
  if(states.isGatOrAbroad == 2){
    states.collegeKey = null;
    states.collegeTxt = '请选择';
  }
  if(states.isGatOrAbroad == 1){
    states.collegeKey = null;
    states.collegeTxt = '';
  }
};
const selectCollege = (key, value) => {
  states.collegeKey = key;
  states.collegeTxt = value;
  if(states.collegeKey == -1){
    states.collegeTxt = null;
  }
};

const selectHighestEdu = (key, value) => {
  clearHighestPart();
  states.highestEduKey = key;
  states.highestEduTxt = value;
};

const selectHighestMajor = (key, value) => {
  states.highestMajorKey = key;
  states.highestMajorTxt = value;
};
const handleHighestGatOrAbroadRadioChange = (key) => {
  states.isHighestGatOrAbroad = key;
  states.isHighestGatOrAbroadTxt = format(states.isHighestGatOrAbroad, 1);
  if(states.isHighestGatOrAbroad == 2){
    states.highestCollegeKey = null;
    states.highestCollegeTxt = '请选择';
  }
  if(states.isHighestGatOrAbroad == 1){
    states.highestCollegeKey = null;
    states.highestCollegeTxt = '';
  }
};
const selectHighestCollege = (key, value) => {
  states.highestCollegeKey = key;
  states.highestCollegeTxt = value;
  if(states.highestCollegeKey == -1){
    states.highestCollegeTxt = null;
  }
};

const selectHighestEduXZ = (key, value) => {
  states.highestEduXZKey = key;
  states.highestEduXZTxt = value;
};

function clearHighestPart() {
  states.isHighestGatOrAbroad = null;
  states.isHighestGatOrAbroadTxt = null;
  states.highestMajorKey = null;
  states.highestMajorTxt = '请选择';
  states.highestCollegeKey = null;
  states.highestCollegeTxt = '请选择';
  states.highestEduXZKey = null;
  states.highestEduXZTxt = '请选择';
}

const selectOrganization = (key, value) => {
  states.organizationKey = key;
  states.organizationTxt = value;
  if (states.organizationKey !== 5){
    states.teachSubjectNumTxt = '请选择';
    states.teachSubjectNumKey = null;
    states.teachSubjectsTxtArray = [];
    states.teachSubjectsKeyArray = [];
    states.isTeachSubjectsMatch = false;
    states.isHasOtherTeachSubjects = false;
  }
};

const selectTuanJob = (key, value) => {
  states.tuanJobKey = key;
  states.tuanJobTxt = value;
};

const selectJobType = (key, value) => {
  states.jobTypeKey = key;
  states.jobTypeTxt = value;
  states.jobLevKey = null;
  states.jobLevTxt = '请选择';
  // console.log("jobTypeKey02==", key);
};

const selectJobLev = (key, value) => {
  states.jobLevKey = key;
  states.jobLevTxt = value;
};

const selectTeachSubjectNum = (key, value) => {
  states.teachSubjectNumKey = key;
  states.teachSubjectNumTxt = value;
  if (states.teachSubjectNumKey == 1){
    states.teachSubjectsKeyArray = [];
    states.teachSubjectsTxtArray = [];
    states.isTeachSubjectsMatch = false;
    states.isHasOtherTeachSubjects = false;
  }
};

const selectTeachSubjects = ({ keys, labels }) => {
  states.teachSubjectsKeyArray = keys;
  states.teachSubjectsTxtArray = labels;
  teachSubjectsMatch();
  hasTeachSubjects();
  if (!states.isTeachSubjectsMatch){
    tipsMsg("提示", "任教学科选择的数量与任教学科门数不一致");
  }
  if (!states.isHasOtherTeachSubjects) {
    states.otherTeachSubject = null;
  }
};


function teachSubjectsMatch(){
  states.isTeachSubjectsMatch = false;
  if(states.teachSubjectNumKey == 1 && states.teachSubjectsKeyArray.length == 0){
    states.isTeachSubjectsMatch = true;
  }
  if(states.teachSubjectNumKey == 2 && states.teachSubjectsKeyArray.length == 1){
    states.isTeachSubjectsMatch = true;
  }
  if(states.teachSubjectNumKey == 3 && states.teachSubjectsKeyArray.length == 2){
    states.isTeachSubjectsMatch = true;
  }
  if(states.teachSubjectNumKey == 4 && states.teachSubjectsKeyArray.length == 3){
    states.isTeachSubjectsMatch = true;
  }
  if(states.teachSubjectNumKey == 5 && states.teachSubjectsKeyArray.length == 4){
    states.isTeachSubjectsMatch = true;
  }
  if(states.teachSubjectNumKey == 6 && states.teachSubjectsKeyArray.length >= 5){
    states.isTeachSubjectsMatch = true;
  }
}

function hasTeachSubjects(){
  states.isHasOtherTeachSubjects = false;
  if(states.teachSubjectsKeyArray.includes(10)){
    states.isHasOtherTeachSubjects = true;
  }
}

const goBack = () => {
  router.go(-1);
};
// 选择字段回调赋值
const handlerSelect = (key, value) => {
  console.log(key, value);
  states.birthday = value;
  if (key == "birthday") {
    state.birthdayFlag = false;
  }
  // if (key == "counselorTime") {
  //   state.counselorTimeFlag = false;
  // }
  // if (key == "sdhsj") {
  //   state.sdhsjFlag = false;
  // }
};

// 用于判断省市区是否必填
let cityList = null;
let districtList = null;

// 选择省市区
const areaData = ref(null);
const selectArea = (area) => {
  cityList = area.cityList
  districtList = area.districtList
  areaData.value = area;
  // console.log("selectArea", areaData.value);
  if(areaData.value && areaData.value.province){
    states.province = areaData.value.province;
    states.city = areaData.value.city;
    states.district = areaData.value.district;
  }
  if(areaData.value && areaData.value.provinceCode){
    states.provinceCode = areaData.value.provinceCode;
    states.cityCode = areaData.value.cityCode
    states.districtCode = areaData.value.districtCode;
  }
  if(areaData.value && areaData.value.city){
    states.city = areaData.value.city;
    states.district = areaData.value.district;
  }
  if(areaData.value && areaData.value.cityCode){
    states.cityCode = areaData.value.cityCode;
    states.districtCode = areaData.value.districtCode;
  }
  if(areaData.value && areaData.value.district){
    states.district = areaData.value.district;
  }
  if(areaData.value && areaData.value.districtCode){
    states.districtCode = areaData.value.districtCode;
  }
};
//输入验证：手机号格式验证
const PhoneFormatDifferent = ref(false);
const errorMessagePhoneFormat = ref('');
const validateInputsPhoneFormat = () => {
  if (states.phone.length != 11) {
    PhoneFormatDifferent.value = true;
    errorMessagePhoneFormat.value = '请输入11位手机号';
  } else {
    PhoneFormatDifferent.value = false;
    errorMessagePhoneFormat.value = '';
  }
};
// 姓名确认
const nameDifferent = ref(false);
const errorMessageName = ref('');
const validateInputsName = () => {
  // 检查两个输入字段的值是否一致
  if (states.name !== states.nameSure) {
    nameDifferent.value = true;
    errorMessageName.value = '两次输入不一致，请确认';
  } else {
    nameDifferent.value = false;
    errorMessageName.value = '';
  }
};

//输入验证：手机号
const PhoneDifferent = ref(false);
const errorMessagePhone = ref('');
const validateInputsPhone = () => {
  // 检查两个输入字段的值是否一致
  if (states.phone !== states.phoneSure) {
    PhoneDifferent.value = true;
    errorMessagePhone.value = '两次输入不一致，请确认';
  } else {
    PhoneDifferent.value = false;
    errorMessagePhone.value = '';
  }
};

//输入验证：本县（市、区、旗）所属乡镇（街道）总辅导员数量
const quFdyDifferent = ref(false);
const errorMessageQuFdy = ref('');
const validateInputsQuFdy = () => {
  // 检查两个输入字段的值是否一致
  if (states.quFdyNum !== states.quFdyNumSure) {
    quFdyDifferent.value = true;
    errorMessageQuFdy.value = '两次输入不一致，请确认';
  } else {
    quFdyDifferent.value = false;
    errorMessageQuFdy.value = '';
  }
};
 
//输入验证：本级红领巾巡讲团人数
const areInputsDifferent = ref(false);
const errorMessage = ref('');
const validateInputs = () => {
  // 检查两个输入字段的值是否一致
  if (states.hljXjtNum !== states.hljXjtNumSure) {
    areInputsDifferent.value = true;
    errorMessage.value = '两次输入不一致，请确认';
  } else {
    areInputsDifferent.value = false;
    errorMessage.value = '';
  }
};

//输入验证：本县（市、区、旗）登记在册的校外辅导员人数
const b63Different = ref(false);
const errorMessageB63 = ref('');
const validateInputsB63 = () => {
  // 检查两个输入字段的值是否一致
  if (states.b63 !== states.b63Sure) {
    b63Different.value = true;
    errorMessageB63.value = '两次输入不一致，请确认';
  } else {
    b63Different.value = false;
    errorMessageB63.value = '';
  }
};

//输入验证：本县（市、区、旗）未建立少先队组织的中小学校数量
const b7Different = ref(false);
const errorMessageB7 = ref('');
const validateInputsB7 = () => {
  // 检查两个输入字段的值是否一致
  if (states.b7 !== states.b7Sure) {
    b7Different.value = true;
    errorMessageB7.value = '两次输入不一致，请确认';
  } else {
    b7Different.value = false;
    errorMessageB7.value = '';
  }
};

//输入验证：本县（市、区、旗）未建立学校少工委的中小学校数量
const b8Different = ref(false);
const errorMessageB8 = ref('');
const validateInputsB8 = () => {
  // 检查两个输入字段的值是否一致
  if (states.b8 !== states.b8Sure) {
    b8Different.value = true;
    errorMessageB8.value = '两次输入不一致，请确认';
  } else {
    b8Different.value = false;
    errorMessageB8.value = '';
  }
};

//输入验证：由本级少工委直管的建有少先队组织的青少年宫数量
const qsngNumDifferent = ref(false);
const errorMessageQsngNum = ref('');
const validateInputsQsngNum = () => {
  // 检查两个输入字段的值是否一致
  if (states.qsngNum !== states.qsngNumSure) {
    qsngNumDifferent.value = true;
    errorMessageQsngNum.value = '两次输入不一致，请确认';
  } else {
    qsngNumDifferent.value = false;
    errorMessageQsngNum.value = '';
  }
};

//输入验证：本县（市、区、旗）建立的街道少工委数量
const jljdsgwNumDifferent = ref(false);
const errorMessageJljdsgwNum = ref('');
const validateInputsJljdsgwNum = () => {
  // 检查两个输入字段的值是否一致
  if (states.jljdsgwNum !== states.jljdsgwNumSure) {
    jljdsgwNumDifferent.value = true;
    errorMessageJljdsgwNum.value = '两次输入不一致，请确认';
  } else {
    jljdsgwNumDifferent.value = false;
    errorMessageJljdsgwNum.value = '';
  }
};

//输入验证：本县（市、区、旗）建立的乡镇少工委数量
const jlxzsgwNumDifferent = ref(false);
const errorMessageJlxzsgwNum = ref('');
const validateInputsJlxzsgwNum = () => {
  // 检查两个输入字段的值是否一致
  if (states.jlxzsgwNum !== states.jlxzsgwNumSure) {
    jlxzsgwNumDifferent.value = true;
    errorMessageJlxzsgwNum.value = '两次输入不一致，请确认';
  } else {
    jlxzsgwNumDifferent.value = false;
    errorMessageJlxzsgwNum.value = '';
  }
};



//输入验证：本县（市、区、旗）建立的社区少工委数量
const jlsqsgwNumDifferent = ref(false);
const errorMessageJlsqsgwNum = ref('');
const validateInputsJlsqsgwNum = () => {
  // 检查两个输入字段的值是否一致
  if (states.jlsqsgwNum !== states.jlsqsgwNumSure) {
    jlsqsgwNumDifferent.value = true;
    errorMessageJlsqsgwNum.value = '两次输入不一致，请确认';
  } else {
    jlsqsgwNumDifferent.value = false;
    errorMessageJlsqsgwNum.value = '';
  }
};

//输入验证：本县（市、区、旗）建立的村少工委数量
const jlcsgwNumDifferent = ref(false);
const errorMessageJlcsgwNum = ref('');
const validateInputsJlcsgwNum = () => {
  // 检查两个输入字段的值是否一致
  if (states.jlcsgwNum !== states.jlcsgwNumSure) {
    jlcsgwNumDifferent.value = true;
    errorMessageJlcsgwNum.value = '两次输入不一致，请确认';
  } else {
    jlcsgwNumDifferent.value = false;
    errorMessageJlcsgwNum.value = '';
  }
};
const onClickButtonSubmit = async () => {

  if (states.name !== states.nameSure)  {
    tipsMsg("提示", "两次姓名输入不一致");
    return false;
  }
  if (states.birthday === null) {
    tipsMsg("提示", "请填写出生年月");
    return false;
  }
  if (states.phone !== states.phoneSure)  {
    tipsMsg("提示", "两次手机号输入不一致");
    return false;
  }
  // if (!states.provinceCode || !states.cityCode || !states.districtCode || states.provinceCode == 0 || states.cityCode == 0 || states.districtCode == 0){
  //   tipsMsg("提示", "请选择行政区域");
  //   return false;
  // }
  // 省级校验（必须选择省）
  if (!states.provinceCode || states.provinceCode == 0) {
    tipsMsg("提示", "请选择行政区域");
    return false;
  }
  /**
   * 判断 市列表 是否有数据，如果有则判断必填，
   * 判断 区列表 是否有数据，如果有则判断必填
   */
  if (cityList && Object.keys(cityList).length > 0) {
      if (!states.cityCode || states.cityCode == 0) {
          tipsMsg("提示", "请选择城市");
          return false;
      }
  }
  if (districtList && Object.keys(districtList).length > 0) {
    if (!states.districtCode || states.districtCode == 0) {
        tipsMsg("提示", "请选择区");
        return false;
      }
  }

  if (!states.fdyLevKey)  {
    tipsMsg("提示", "请选择总辅导员级别");
    return false;
  }
  if(states.fdyLevKey == 3){
    if (states.quFdyNum !== states.quFdyNumSure)  {
      tipsMsg("提示", "本县（市、区、旗）所属乡镇（街道）总辅导员数量输入不一致");
      return false;
    }
  }
  if (states.isHljXjt == true){
    if (states.hljXjtNum !== states.hljXjtNumSure)  {
      tipsMsg("提示", "本级红领巾巡讲团人数输入不一致");
      return false;
    }
  }
  if (!states.eduKey)  {
    tipsMsg("提示", "请选择全日制教育学历");
    return false;
  }
  if (!states.majorKey)  {
    tipsMsg("提示", "请选择所学专业大类");
    return false;
  }
  if (states.isGatOrAbroad == 2 && !states.collegeKey) {
    tipsMsg("提示", "请选择毕业院校");
    return false;
  }
  if (!states.highestEduKey)  {
    tipsMsg("提示", "请选择最高教育学历");
    return false;
  }
  if (states.highestEduKey !== 1)  {
    if(!states.highestMajorKey){
      tipsMsg("提示", "请选择最高教育学历所学专业大类");
      return false;
    }
    if(states.isHighestGatOrAbroad == 2 && !states.highestCollegeKey){
      tipsMsg("提示", "请选择最高教育学历毕业院校");
      return false;
    }
    if(!states.highestEduXZKey){
      tipsMsg("提示", "请选择最高教育学历性质");
      return false;
    }
  }
  if (!states.organizationKey)  {
    tipsMsg("提示", "请选择本人编制所在单位");
    return false;
  }
  if (!states.tuanJobKey)  {
    tipsMsg("提示", "请选择团内职务");
    return false;
  }
  if (!states.jobTypeKey)  {
    tipsMsg("提示", "请选择本人编制类型");
    return false;
  }
  if (!states.jobLevKey && (states.jobTypeKey == 1 || states.jobTypeKey == 2))  {
    tipsMsg("提示", "请选择行政（事业）级别");
    return false;
  }
  if (states.organizationKey == 5){
    if (!states.teachSubjectNumKey) {
      tipsMsg("提示", "请选择任教学科门数");
      return false;
    }
    if (states.teachSubjectNumKey && states.teachSubjectNumKey != 1)  {
      if (states.teachSubjectsKeyArray.length == 0)  {
        tipsMsg("提示", "请选择任教学科");
        return false;
      }
      if (!states.isTeachSubjectsMatch){
        tipsMsg("提示", "任教学科选择的数量与任教学科门数不一致");
        return false;
      }
    }
  }
  if (states.qsngNum !== states.qsngNumSure)  {
    tipsMsg("提示", "由本级少工委直管的建有少先队组织的青少年宫数量输入不一致");
    return false;
  }
  if(states.fdyLevKey == 3){
    if (states.b63 !== states.b63Sure)  {
      tipsMsg("提示", "本县（市、区、旗）登记在册的校外辅导员人数输入不一致");
      return false;
    }
    if (states.b7 !== states.b7Sure)  {
      tipsMsg("提示", "本县（市、区、旗）未建立少先队组织的中小学校数量输入不一致");
      return false;
    }
    if (states.b8 !== states.b8Sure)  {
      tipsMsg("提示", "本县（市、区、旗）未建立学校少工委的中小学校数量输入不一致");
      return false;
    }
    if (states.jljdsgwNum !== states.jljdsgwNumSure)  {
      tipsMsg("提示", "本县（市、区、旗）建立的街道少工委数量输入不一致");
      return false;
    }
    if (states.jlxzsgwNum !== states.jlxzsgwNumSure)  {
      tipsMsg("提示", "本县（市、区、旗）建立的乡镇少工委数量输入不一致");
      return false;
    }
    if (states.jlsqsgwNum !== states.jlsqsgwNumSure)  {
      tipsMsg("提示", "本县（市、区、旗）建立的社区少工委数量输入不一致");
      return false;
    }
    if (states.jlcsgwNum !== states.jlcsgwNumSure)  {
      tipsMsg("提示", "本县（市、区、旗）建立的村少工委数量输入不一致");
      return false;
    }
  }
  
  Dialog.confirm({
    title: "提示",
    message: "你确定要提交吗？",
  })
    .then(() => {
      proxy.$showLoading();
      states.zzmmTxt = format(states.zzmm, 21);
      states.sexTxt = format(states.sex, 12);
      states.isHljXjtTxt = format(states.isHljXjt, 1);
      add(states);
    })
    .catch(() => {
      // on cancel
    });  
};
const add = async (values) => {
  let arr = [];
  const { id, type } = route.query;
  let data = {
    formId: 37,
    list: [],
  };

  let fn = addForm;
  if (type == 1) {
    data.id = id;
    fn = editForm;
    console.log("editForm---", "editForm---");
  }

  // const whiteList = [
  //   "schoolTypeFlag",
  //   "schoolTypeTxt",
  //   "rules",
  //   "birthdayFlag",
  //   "counselorTimeFlag",
  //   "sdhsjFlag",
  // ];

  for (let i in values) {
    let val = values[i];
    if (i == "birthday" && values[i] && values[i].toString().length > 10) {
      val = val / 1000;
      values[i] = val;
    }
    // if (i == "counselorTime" && values[i] && values[i].toString().length > 10) {
    //   val = val / 1000;
    //   values[i] = val;
    // }
    // if (i == "sdhsj" && values[i] && values[i].toString().length > 10) {
    //   val = val / 1000;
    //   values[i] = val;
    // }
  }

  for (const item in values) {
    let obj = {
      fieldCode: item,
      value: values[item],
    };
    // if (whiteList.indexOf(item) !== -1) {
    //   continue;
    // }
    if (values[item] !== "请选择" && (values[item] || values[item] == 0)) {
      arr.push(obj);
    }
  }
  data.list = arr;

  //随机获取AES的key
  let aesKey = getKey().toLowerCase();
  let param = {
    encryptData: encrypt(data, aesKey), //AES加密后的数据
    encrypted: rsaUtil.encrypt(aesKey, serverPublicKey), //后端RSA公钥加密后的AES的key
    // publicKey: window.jsPublicKey //前端公钥
  };

  try {
    const res = await fn(param);
    console.log("res -> ", data);
    if (res.code === 10000) {
      proxy.$closeLoading();
      Dialog.alert({
        message: "提交成功",
      }).then(() => {
        goTo();
      });
    } else {
      proxy.$closeLoading();
    }
  } catch (error) {
    proxy.$closeLoading();
    console.log("res error -> ", error);
  }
}
const goTo = () => {
  // const { id, url } = route.query;
  // if (id) {
  router.push({ path: "/info/xtj" });
  // }
};

const errors = ref(null);
const errorsMsg = ref([]);
const handleFailed = (errorInfo) => {
  errors.value = errorInfo;
  errorsMsg.value = errors.value.errors;
  if(errorsMsg.value && errorsMsg.value.length > 0){
    tipsMsg("提示", errorsMsg.value[0].message);
  }
};

onMounted(() => {
  const { type } = route.query;
  if (type == 1) {
    getInfo();
  }
});
const getInfo = async () => {
  const { id } = route.query;
  const result = await getsubmitData({ dataId: id });
  const { code, data } = result;
  console.log("data ->", data);
  if (code == 10000 && data) {
    const newObj = {};
    for (const i of data.list) {
      let val = i.value;
      // if (i.fieldCode == "schoolType") {
      //   const st = schoolTypes.filter((r) => r.key == i.value);
      //   if (st.length > 0) {
      //     state.schoolTypeTxt = st[0].value;
      //   }
      // }
      if (
        i.fieldCode == "birthday"
      ) {
        val = val * 1000;
      }
      newObj[i.fieldCode] = val;
    }
    //   赋值
    Object.assign(states, newObj);
  }
};
</script>

<style lang="less" scoped>
// @import "../../../common/style/mixin";
.radioStyle {
  background-color: #f90;
}

.back_left {
  width: 10%;
  height: 0.883rem;
  position: absolute;
  top: 0.233rem;
  left: 0.133rem;
  z-index: 99;
}
.go_back {
  height: 0.383rem;
  padding: 0.033rem 0 0 0.333rem;
  overflow: visible;
  color: rgb(255, 255, 255);
  font-size: 28px;
  z-index: 99;
}
:deep(.van-field__control--custom) {
  display: block;
}
.radioFlex :deep(.van-field__control--custom) {
  display: flex;
}

:deep(.van-cell__value),
:deep(.van-field__control),
:deep(.van-cell__right-icon) {
  color: #ff6865;
}
:deep(.van-radio__icon .van-icon) {
  border: 0.02667rem solid #ff6865 !important;
}
:deep(.van-cell__title) {
  color: #646566;
}
:deep(.van-radio-group) {
  padding: 0.168rem 0;
}
.title {
  text-align: center;
  font-size: 17px;
  margin-top: 10px;
  .tip {
    font-size: 12px;
  }
}
.fz-bold {
  font-weight: bold !important;
  color: red;
}
.d_f{
  display: flex;
  flex-direction: column;
}
.d_f :deep(.van-field__label) {
  width: 100%;
}
.d_f :deep(.van-field__body) {
  margin-top: 10px;
}
</style>
